import { Box, Button, Link, Paper, TableBody, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import DeniedCookInterface from "../../interfaces/Cook/DeniedCookInterface";
import moment from "moment";
import { moduleType } from "../../enums/common";
import { CustomTableRowTR, StyledTable, TableData, TableHeader, TableWrapper } from "../../styles/commonStyles";


interface InputProps {
  cookData: DeniedCookInterface[];
  callBack: (trialId: number, cookId: number) => void;
  id: number;
  refresh: () => void;
  type?: moduleType;
  toggleEmergency?: (cancelId: number) => void;
}

const DeniedCooks = (props: InputProps) => {
  return (
    <TableWrapper>
      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
              <TableHeader>Id</TableHeader>
              <TableHeader>TrialId</TableHeader>
              <TableHeader>Cook Id</TableHeader>
              <TableHeader>Cook Name</TableHeader>
              <TableHeader>Reason</TableHeader>
              <TableHeader>Leave Id</TableHeader>
              <TableHeader>Denied By</TableHeader>
              <TableHeader>Denied By Type</TableHeader>
              <TableHeader>Emergency Reverted By</TableHeader>
              <TableHeader>Emergency Reverted At</TableHeader>
              <TableHeader>Action</TableHeader>
              <TableHeader>Emergency Action</TableHeader>
              <TableHeader>Created At</TableHeader>
              <TableHeader>Updated At</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.cookData.map((cook, index) => {
              return (
                <CustomTableRowTR key={index + ""}>
                  <TableData>
                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      {cook.id || "Not Available"}
                      {cook?.isEmergency && (
                        <Tooltip title="Emergency">
                          <LocalFireDepartmentIcon fontSize="small" sx={{ color: "#ef4444" }} />
                        </Tooltip>
                      )}
                    </span>
                  </TableData>
                  <TableData>{props.id || "Not Available"}</TableData>
                  <TableData>
                    <Link href={`/#/cooks/${cook?.cookId}/show`}>
                      <p style={{ margin: 0 }}>{cook?.cookId || "Not Available"}</p>
                    </Link>
                  </TableData>
                  <TableData>
                    {`${cook.cookFullProfile.firstName} ${cook.cookFullProfile.lastName}` ||
                      "Not Available"}
                  </TableData>
                  <TableData>{cook?.cancellationReason || "---"}</TableData>
                  <TableData>
                    <Link href={`/#/CookLeaves/${cook?.leaveId}/show`}>
                      <p style={{ margin: 0 }}>{cook?.leaveId || "---"}</p>
                    </Link>
                  </TableData>
                  <TableData>{cook?.deniedBy || "---"}</TableData>
                  <TableData>{cook?.deniedByType || "---"}</TableData>
                  <TableData>{cook?.emergencyRevertedBy || "---"}</TableData>
                  <TableData>
                    {cook?.emergencyRevertedAt
                      ? moment(cook.emergencyRevertedAt).format("DD-MMM-YYYY HH:mm:ss")
                      : "---"}
                  </TableData>
                  <TableData>
                    {!cook?.deletedAt ? (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                          EventBus.emitEvent(
                            EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,
                            {
                              title: "Are you sure?",
                              message: "Please confirm to revert the cook",
                              successLabel: "Confirm",
                              failureLabel: "Cancel",
                              onClose: (confirmed: boolean) => {
                                if (confirmed) {
                                  props.callBack(props.type ? cook.id : props.id, cook.cookId);
                                  props.refresh();
                                }
                              },
                            }
                          );
                        }}
                      >
                        Revert
                      </Button>
                    ) : (
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
                        <span style={{ fontSize: "11px", color: "#7F1D1D", fontWeight: 500 }}>Deleted By</span>
                        {cook?.deleteById != null && (
                          <Link href={`/#/AdminUsers/${cook.deleteById}/show`}>
                            {cook.deleteById}
                          </Link>
                        )}
                      </Box>
                    )}
                  </TableData>
                  <TableData>
                    {!cook?.deletedAt && props.toggleEmergency && cook?.isEmergency && (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          EventBus.emitEvent(
                            EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,
                            {
                              title: "Remove Emergency?",
                              message: "Please confirm to remove emergency status from this denial",
                              successLabel: "Confirm",
                              failureLabel: "Cancel",
                              onClose: (confirmed: boolean) => {
                                if (confirmed) {
                                  props.toggleEmergency!(cook.id);
                                }
                              },
                            }
                          );
                        }}
                      >
                        Remove Emergency
                      </Button>
                    )}
                  </TableData>
                  <TableData>
                    {cook?.createdAt && moment(cook?.createdAt).format("DD-MMM-YYYY HH:mm:ss")}
                  </TableData>
                  <TableData>
                    {cook?.updatedAt && moment(cook?.updatedAt).format("DD-MMM-YYYY HH:mm:ss")}
                  </TableData>
                </CustomTableRowTR>
              );
            })}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

export default DeniedCooks;
